import { MenuItem } from './menu.model';

export const MENU: MenuItem[] = [
    // {
    //     id: 1,
    //     label: 'Menu',
    //     isTitle: true
    // },
    {
        id: 2,
        label: 'Dashboard',
        icon: 'bx bx-home-alt',
        link: '/dashboard',
      
    },
    {
        id: 2,
        label: 'Locations',
        icon: 'bx bx-map',
        link: '/locations',
      
    },
    {
        id: 2,
        label: 'Api Key Settings',
        icon: 'bx bx-key',
        link: '/api-keys',
    },
    {
        id: 2,
        label: 'E-Bills',
        icon: 'bx bx-receipt',
        link: '/bills',
    },
    // {
    //     id: 2,
    //     label: 'Feedbacks',
    //     icon: 'bx bx-comment',
    //     link: '/feedbacks',
    // },
    
    
];

